import { render, staticRenderFns } from "./menu-notifications.vue?vue&type=template&id=b2242dba&"
import script from "./menu-notifications.vue?vue&type=script&lang=js&"
export * from "./menu-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports